import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import env from 'env';
import _ from 'lodash';
import update from 'immutability-helper';
import axios from 'axios';
import ApplianceIcon from '../../icons/appliance.svg';
import QWLogo from '../../icons/qube-wire-logo-portal.svg';
import WorkOrders from '../../icons/work-orders.svg';
import Company from '../../icons/company.svg';
import Drive from '../../icons/drive.svg';
import Reports from '../../icons/reports.svg';
import DrivesModalView from '../../views/drive-inventory-view/DrivesModalView';
import I18n from '../../../config/i18n';
import * as localstorage from '../../common/utils/localstorage';
import * as cookie from '../../common/utils/cookie';
import * as routePath from '../../common/utils/routePath';
import * as enums from '../../common/utils/enums';
import { getCurrentPath } from '../../common/utils';
import DrivesModalEdit from '../../views/inventory-edit/DrivesModalEdit';
import { withRouter } from '../../common/hoc/withRouter';
import NavMenu from './NavMenu';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showWorkOrdersSubmenu: false,
      showSettingsSubmenu: false,
    };

    this.handleSaveDrives = this.handleSaveDrives.bind(this);
    this.toggleWorkOrdersSubmenu = this.toggleWorkOrdersSubmenu.bind(this);
    this.handleReportsRedirect = this.handleReportsRedirect.bind(this);
    this.toggleSettingsSubmenu = this.toggleSettingsSubmenu.bind(this);
  }

  handleServiceAreas() {
    this.props.history.push('/account/service-areas');
  }

  handleCompanyDetails() {
    this.props.history.push('/account/company-details');
  }

  handleSaveDrives(drives) {
    this.props.saveDriveInventory(this.props.user.companyId, drives);
  }

  renderDrivesModal() {
    let { driveTypes, inventory, registrationApproval } = this.props;
    if (
      registrationApproval.type === enums.ApprovalTypes.REGISTRATION &&
      registrationApproval.status === enums.ApprovalStatus.APPROVED
    ) {
      return (
        <DrivesModalEdit
          ref={(element) => (this.drivesModal = element)}
          inventory={inventory}
          driveTypes={driveTypes}
          onSave={this.handleSaveDrives}
        />
      );
    } else if (
      registrationApproval.type === enums.ApprovalTypes.REGISTRATION &&
      registrationApproval.status === enums.ApprovalStatus.PENDING
    ) {
      return (
        <DrivesModalView
          ref={(element) => (this.drivesModal = element)}
          inventory={inventory}
        />
      );
    } else {
      return <div />;
    }
  }

  shouldIncludeRegDataRelatedSubmenus(registrationApprovalStatus) {
    return (
      registrationApprovalStatus === enums.ApprovalStatus.PENDING ||
      registrationApprovalStatus === enums.ApprovalStatus.APPROVED
    );
  }

  getSettingsSubmenuItems() {
    let { user, registrationApproval } = this.props;
    let isAdmin = user.roleNames.includes(enums.UserRoleNames.ADMIN);

    let submenuItems = {};

    if (this.shouldIncludeRegDataRelatedSubmenus(registrationApproval.status)) {
      submenuItems.serviceAreas = I18n.t('serviceAreas');
    }

    _.extend(
      submenuItems,
      isAdmin
        ? {
            calendar: I18n.t('calendar'),
            companySettings: I18n.t('companySettings'),
            companyProfile: I18n.t('companyProfile'),
            manageUsers: I18n.t('manageUsers'),
            switchCompany: I18n.t('switchCompany'),
            signOut: I18n.t('signOut'),
          }
        : {
            calendar: I18n.t('calendar'),
            companyProfile: I18n.t('companyProfile'),
            switchCompany: I18n.t('switchCompany'),
            signOut: I18n.t('signOut'),
          },
    );

    return submenuItems;
  }

  getWorkOrdersSubmenuRedirectLinks() {
    return {
      active: _.debounce(
        this.handleRedirect.bind(this, `${routePath.workOrdersRoute}`),
        200,
      ),
      archive: _.debounce(
        this.handleRedirect.bind(this, `${routePath.workOrdersPastRoute}`),
        200,
      ),
    };
  }

  getSettingsSubmenuRedirectLinks() {
    let { user, registrationApproval } = this.props;

    let menuActions = {
      calendar: _.debounce(
        this.handleRedirect.bind(this, `${routePath.calendarRoute}`),
        200,
      ),
      companyProfile: _.debounce(
        this.handleSettingsRedirect.bind(
          this,
          enums.SettingsMenuActions.SHOW_COMPANY_PROFILE,
          `${env.qubeAccountUrl}/account`,
        ),
        200,
      ),
      switchCompany: _.debounce(this.switchUserCompany.bind(this), 200),
      signOut: _.debounce(
        this.handleSettingsRedirect.bind(
          this,
          enums.SettingsMenuActions.SIGN_OUT,
          `${env.qwPartnersBaseUrl}/v1/web/auth/logout`,
        ),
        200,
      ),
    };

    if (user.roleNames.includes(enums.UserRoleNames.ADMIN)) {
      _.extend(menuActions, {
        manageUsers: _.debounce(
          this.handleSettingsRedirect.bind(
            this,
            enums.SettingsMenuActions.MANAGE_USERS,
            `${env.qubeAccountUrl}/users`,
          ),
          200,
        ),
        companySettings: _.debounce(
          this.handleRedirect.bind(this, `${routePath.companySettingsRoute}`),
          200,
        ),
      });
    }

    if (this.shouldIncludeRegDataRelatedSubmenus(registrationApproval.status)) {
      _.extend(menuActions, {
        serviceAreas: _.debounce(
          this.handleRedirect.bind(
            this,
            `${routePath.currentServiceAreasRoute}`,
          ),
          200,
        ),
      });
    }

    return menuActions;
  }

  handleRedirect(link) {
    this.props.history.push(link);
  }

  handleSettingsRedirect(action, link) {
    if (action === enums.SettingsMenuActions.SIGN_OUT) {
      cookie.removeAll();
      localstorage.removeAll();
      sessionStorage.clear();
      window.location = link;
    } else {
      window.open(link, '_blank');
    }
  }

  switchUserCompany = () => {
    const token = this.props.user && this.props.user.accessToken;
    cookie.removeAll();
    localstorage.removeAll();
    sessionStorage.clear();
    if (token) {
      axios
        .delete(`${env.qubeAccountUrl}/oauth/token?token=${token}`)
        .catch((e) => console.error(e));
    }
    window.location = `${env.qwPartnersBaseUrl}/v1/web/auth/provider`;
  };

  toggleWorkOrdersSubmenu(status) {
    let newState = update(this.state, {
      showWorkOrdersSubmenu: { $set: status },
    });
    this.setState(newState);
  }

  toggleSettingsSubmenu(status) {
    let newState = update(this.state, {
      showSettingsSubmenu: { $set: status },
    });
    this.setState(newState);
  }

  shouldShowWorkOrdersMenu(currentPath) {
    let { registrationApproval } = this.props;

    let isPartner =
      registrationApproval.status === enums.ApprovalStatus.APPROVED;
    let isRegisterApprovedRoute =
      currentPath === routePath.registerApprovedRoute;

    return isPartner && !isRegisterApprovedRoute;
  }

  shouldShowReportsMenu(currentPath) {
    let { registrationApproval } = this.props;

    let isPartner =
      registrationApproval.status === enums.ApprovalStatus.APPROVED;
    let isRegisterApprovedRoute =
      currentPath === routePath.registerApprovedRoute;

    return isPartner && !isRegisterApprovedRoute;
  }

  shouldShowDriveMenu(currentPath) {
    let { registrationApproval } = this.props;

    let isRegistrationStatusInAllowedStates =
      registrationApproval.status === enums.ApprovalStatus.PENDING ||
      registrationApproval.status === enums.ApprovalStatus.APPROVED;
    let isRegisterApprovedRoute =
      currentPath === routePath.registerApprovedRoute;

    return isRegistrationStatusInAllowedStates && !isRegisterApprovedRoute;
  }

  handleReportsRedirect() {
    _.debounce(this.handleRedirect(`${routePath.workOrderReportsRoute}`), 200);
  }

  render() {
    let { user } = this.props;

    let currentPath = getCurrentPath();
    let companyName = user.companyName;

    return (
      <div className="app__header">
        <div className="ui-toolbar" style={{ height: '64px' }}>
          <div className="ui-toolbar__group" style={{ marginLeft: '-24px' }}>
            <QWLogo className="svg-icon svg-logo-3x" />
          </div>
          <div className="ui-toolbar__group">
            <div>
              <div
                id="work-order-menu"
                className={cx('sm-col mr3 nav-menu', {
                  hide: !this.shouldShowWorkOrdersMenu(currentPath),
                  active: currentPath === routePath.applianceRoute,
                })}
                style={{ textAlign: 'center' }}
                title={I18n.t('appliances')}
                onClick={() =>
                  this.handleRedirect(`${routePath.applianceRoute}`)
                }
              >
                <ApplianceIcon className="svg-icon svg-2x" />
                <div className="menu-text-item">{I18n.t('appliances')}</div>
              </div>
              <div
                className={cx('sm-col mr3 nav-menu', {
                  hide: !this.shouldShowDriveMenu(currentPath),
                })}
                style={{ textAlign: 'center' }}
                onClick={() => this.drivesModal.handleOpen()}
              >
                <Drive className="svg-icon svg-2x" />
                <div className="menu-text pt2">{I18n.t('drive')}</div>
              </div>

              <div
                id="work-order-menu"
                className={cx('sm-col mr3 nav-menu', {
                  hide: !this.shouldShowWorkOrdersMenu(currentPath),
                  active:
                    currentPath === routePath.workOrdersRoute ||
                    currentPath === routePath.workOrdersPastRoute,
                })}
                style={{ textAlign: 'center' }}
                title={I18n.t('workOrders')}
                onClick={() =>
                  this.handleRedirect(`${routePath.workOrdersRoute}`)
                }
              >
                <WorkOrders className="svg-icon svg-2x" />
                <div className="menu-text-item">{I18n.t('workOrders')}</div>
              </div>
              <div
                className={cx('sm-col mr3 nav-menu', {
                  hide: !this.shouldShowReportsMenu(currentPath),
                  active: currentPath === routePath.workOrderReportsRoute,
                })}
                style={{ textAlign: 'center' }}
                onClick={this.handleReportsRedirect}
              >
                <Reports className="svg-icon svg-2x" />
                <div className="menu-text pt2">{I18n.t('reports')}</div>
              </div>
              <div
                className="sm-col mr1 nav-menu"
                style={{ textAlign: 'center' }}
                title={companyName}
              >
                <NavMenu
                  display={this.state.showSettingsSubmenu}
                  displayHandler={this.toggleSettingsSubmenu}
                  navElement={<Company className="svg-icon svg-2x" />}
                  menuTitle={
                    <div className="menu-text pt2">
                      {companyName.length > 15
                        ? companyName.substr(0, 15) + '...'
                        : companyName}
                    </div>
                  }
                  submenu={this.getSettingsSubmenuItems()}
                  redirectLinks={this.getSettingsSubmenuRedirectLinks()}
                />
              </div>
            </div>
          </div>
        </div>
        {this.renderDrivesModal()}
      </div>
    );
  }
}

Header.propTypes = {
  user: PropTypes.object.isRequired,
  registrationApproval: PropTypes.object.isRequired,
};

export default withRouter(Header);
